import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NiceFormErrorModule, ResolveDirective } from "@recursyve/nice-ui-kit.v2";
import { PasswordRuleClassPipe } from "./pipes/password-rule-class.pipe";
import { PasswordRuleIconPipe } from "./pipes/password-rule-icon.pipe";
import { RegisterOwnerFormComponent } from "./register-owner-form.component";

@NgModule({
    declarations: [RegisterOwnerFormComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        NiceFormErrorModule,
        PasswordRuleClassPipe,
        PasswordRuleIconPipe,
        ReactiveFormsModule,
        ResolveDirective,
        RouterModule,
        TranslateModule,
        MatProgressSpinnerModule
    ],
    exports: [RegisterOwnerFormComponent]
})
export class RegisterOwnerFormModule {}
